import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Comanda va dura mai mult/mai puțin?',
  text: {
    [OrderMethod.Pickup]:
      'Clientul se așteaptă ca comanda să fie gata pentru ridicare <strong>{{date}}</strong> la <strong>{{time}}</strong><br/> Dacă este necesar, puteți schimba ora aici.',
    [OrderMethod.OnSite]:
      'Clientul se așteaptă ca comanda să fie gata pentru ridicare <strong>{{date}}</strong> la <strong>{{time}}</strong><br/> Dacă este necesar, puteți schimba ora aici.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Clientul se așteaptă ca comanda să fie livrată <strong>{{date}}</strong> la <strong>{{time}}</strong><br/> Dacă este necesar, puteți schimba ora aici.',
      [DeliveryMode.External]: 'Șoferul va sosi să ridice comanda la <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Astăzi',
  },
  confidence_labels: {
    estimated: ' (estimat!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Confirmă noua oră de ridicare',
    confirm_delivery: 'Confirmă noua oră de livrare',
  },
  confirmation_modal: {
    description: 'Sigur doriți să schimbați ora din {{currentPickupTime}} în {{newPickupTime}}?',
    ok_button_text: 'Confirmă noua oră',
    cancel_button_text: 'Nu, revenire la ora originală',
  },
};
